<template>
  <v-navigation-drawer
   app
   clipped
  :value="value"
  @input="onNavToggle"
  expand-on-hover
  mini-variant
  mini-variant-width="64"
  width="260"
  hide-overlay
  >
    <v-divider></v-divider>
    <!-- NAVIGATION -->
    <v-list class="pt-0">
      <NavItem
        :route="{name: routeName.DASHBOARD}"
        icon="dashboard"
        :title="$t('DASHBOARD')"
        :badge="hasUnseenRelease"
      />

      <v-list-group
          v-if="can('show users')"
          no-action
      >
          <template v-slot:activator>
            <v-list-item
              class="pa-0 ma-0"
              active-class="primary--text font-weight-bold"
            >
              <v-list-item-action>
                <v-icon>supervisor_account</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ $t('MANAGE_USERS')}} </v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            v-if="can('show users')"
            :to="{name: routeName.USER}"
          >
            <v-list-item-title>{{ $t('USERS')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
             v-if="can('show users')"
            :to="{name: routeName.ROLE}"
          >
            <v-list-item-title>{{ $t('ROLES')}}</v-list-item-title>
          </v-list-item>

      </v-list-group>

      <v-list-group
          v-if="can('campaign_manager')"
          no-action
      >
          <template v-slot:activator>
            <v-list-item
              class="pa-0 ma-0"
              active-class="primary--text font-weight-bold"
            >
              <v-list-item-action>
                <v-icon>notifications</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ $t('CAMPAIGN_MANAGEMENT')}} </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-if="can('campaign_manager')"
            :to="{name: routeName.CAMPAIGN_TEACHER}"
          >
            <v-list-item-title>{{ $t('CAMPAIGN_TEACHER')}}</v-list-item-title>
          </v-list-item>
          <v-list-item
             v-if="can('campaign_manager')"
            :to="{name: routeName.CAMPAIGN_SUBJECT}"
          >
            <v-list-item-title>{{ $t('CAMPAIGN_SUBJECT')}}</v-list-item-title>
          </v-list-item>
          <v-list-item
             v-if="can('campaign_manager')"
            :to="{name: routeName.CAMPAIGN_SCHOOL}"
          >
            <v-list-item-title>{{ $t('CAMPAIGN_SCHOOL')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
             v-if="can('campaign_manager')"
            :to="{name: routeName.CAMPAIGN_SCHOOL_RESULT}"
          >
            <v-list-item-title>{{ $t('CAMPAIGN_SCHOOL_RESULT')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
             v-if="can('campaign_manager')"
            :to="{name: routeName.CAMPAIGN_REPORT}"
          >
            <v-list-item-title>{{ $t('REPORT')}}</v-list-item-title>
          </v-list-item>

      </v-list-group>

      <v-list-group
          v-if="can('campaign_manager')"
          no-action
      >
          <template v-slot:activator>
            <v-list-item
              class="pa-0 ma-0"
              active-class="primary--text font-weight-bold"
            >
              <v-list-item-action>
                <v-icon>print</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('PRINT_BULLETTINS')}}</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-if="can('campaign_manager')"
            :to="{name: routeName.PRINT_BULLETTINS}"
          >
            <v-list-item-title>{{$t('PRINT_BULLETTINS')}}</v-list-item-title>
          </v-list-item>

      </v-list-group>

      <v-list-group
          no-action
          v-if="can('show adoptions') || can('show adoptions report')"
      >
          <template v-slot:activator>
            <v-list-item
              class="pa-0 ma-0"
              active-class="primary--text font-weight-bold"
            >
              <v-list-item-action>
                <v-icon>local_library</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ $t('ADOPTION_MANAGEMENT')}} </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-if="can('show adoptions')"
            :to="{name: routeName.ADOPTION}"
          >
            <v-list-item-title>{{ $t('ADOPTION')}}</v-list-item-title>
          </v-list-item>
          <v-list-item
          v-if="can('show adoptions report')"
            :to="{name: routeName.ADOPTION_REPORT}"
          >
            <v-list-item-title>{{ $t('ADOPTION_REPORT')}}</v-list-item-title>
          </v-list-item>
      </v-list-group>

      <v-list-group
          no-action
      >
          <template v-slot:activator>
            <v-list-item
              class="pa-0 ma-0"
              active-class="primary--text font-weight-bold"
            >
              <v-list-item-action>
                <v-icon>work</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ $t('BASIC_ARCHIVES')}} </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-if="can('show editors')"
            :to="{name: routeName.EDITOR}"
          >
            <v-list-item-title>{{ $t('EDITORS')}}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="can('show editors')"
            :to="{name: routeName.EDITOR_GROUP}"
          >
            <v-list-item-title>{{ $t('EDITORS_GROUP')}}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="can('show books')"
            :to="{name: routeName.BOOK}"
          >
            <v-list-item-title>{{ $t('BOOKS')}}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="can('show teachers')"
            :to="{name: routeName.TEACHER}"
          >
            <v-list-item-title>{{ $t('TEACHERS')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="can('show propagandists')"
            :to="{name: routeName.PROPAGANDIST}"
          >
            <v-list-item-title>{{ $t('PROPAGANDISTS')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="can('show schools')"
            :to="{name: routeName.SCHOOL}"
          >
            <v-list-item-title>{{ $t('SCHOOLS')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="can('show schools_type')"
            :to="{name: routeName.SCHOOL_TYPE}"
          >
            <v-list-item-title>{{ $t('SCHOOLS_TYPES')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="can('show zones')"
            :to="{name: routeName.ZONE}"
          >
            <v-list-item-title>{{ $t('ZONES')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="can('show subjects')"
            :to="{name: routeName.SUBJECT}"
          >
            <v-list-item-title>{{ $t('SUBJECTS')}}</v-list-item-title>
          </v-list-item>
      </v-list-group>

      <v-list-group
          no-action
          v-if="can('show warehouses')
          || can('show warehouses_unload')
          || can('show warehouses_load')
          || can('show warehouses_transfer')"
      >
          <template v-slot:activator>
            <v-list-item
              class="pa-0 ma-0"
              active-class="primary--text font-weight-bold"
            >
              <v-list-item-action>
                <v-icon>storefront</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ $t('WAREHOUSE_MANAGEMENT')}} </v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            v-if="can('show warehouses')"
            :to="{name: routeName.WAREHOUSE}"
          >
            <v-list-item-title>{{ $t('WAREHOUSES')}}</v-list-item-title>
          </v-list-item>

          <!--v-list-item
            v-if="can('show warehouses_unload')"
            :to="{name: routeName.WAREHOUSE_UNLOAD}"
          >
            <v-list-item-title>{{ $t('WAREHOUSES_UNLOAD')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="can('show warehouses_load')"
            :to="{name: routeName.WAREHOUSE_LOAD}"
          >
            <v-list-item-title>{{ $t('WAREHOUSES_LOAD')}}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="can('show warehouses_transfer')"
            :to="{name: routeName.WAREHOUSE_TRANSFER}"
          >
            <v-list-item-title>{{ $t('WAREHOUSES_TRANSFER')}}</v-list-item-title>
          </v-list-item-->

          <v-list-item
            v-if="can('show boxes')"
            :to="{name: routeName.BOXES}"
          >
            <v-list-item-title>{{ $t('BOXES')}}</v-list-item-title>
          </v-list-item>

      </v-list-group>

      <v-list-group
          no-action
          v-if="can('communication_manager')"
      >
          <template v-slot:activator>
            <v-list-item
              class="pa-0 ma-0"
              active-class="primary--text font-weight-bold"
            >
              <v-list-item-action>
                <v-icon>send</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ $t('COMMUNICATION') }}</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            :to="{name: routeName.COMMUNICATION}"
          >
            <v-list-item-title>{{ $t('EMAIL') }}</v-list-item-title>
          </v-list-item>
      </v-list-group>

      <NavItem
        v-if="can('show anomalies')"
        :route="{name: routeName.ANOMALY_DASHBOARD}"
        icon="warning"
        title="Anomalie"
      />

      <NavItem
        :route="{name: routeName.SUPPORT}"
        icon="help_outline"
        :title="$t('SUPPORT')"
      />

      <v-list-group
          no-action
          v-if="can('manage settings')"
      >
          <template v-slot:activator>
            <v-list-item
              class="pa-0 ma-0"
              active-class="primary--text font-weight-bold"

            >
              <v-list-item-action>
                <v-icon>settings</v-icon>
              </v-list-item-action>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            :to="{name: routeName.APP_SETTINGS}"
          >
            <v-list-item-title>{{ $t('APP') }}</v-list-item-title>
          </v-list-item>
      </v-list-group>

    </v-list>
  </v-navigation-drawer>
</template>
<script>
  import { mapGetters } from 'vuex';

  import NavItem from './TheNav/NavItem';
  import releases from '../../assets/releases.json';
  import { getLatestVersion, compareVersions } from '../../utils/version';

  const LAST_SEEN_RELEASE_KEY = 'plas:lastSeenReleaseVersion';

  export default {
    name: 'TheNav',
    components: { NavItem },
    props: {
      value: Boolean,
    },
    data() {
      return {
        lastSeenVersion: this.readLastSeen(),
      };
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
      latestReleaseVersion() {
        return getLatestVersion(releases);
      },
      hasUnseenRelease() {
        if (!this.latestReleaseVersion) return false;
        if (!this.lastSeenVersion) return true;
        return compareVersions(this.latestReleaseVersion, this.lastSeenVersion) > 0;
      },
    },
    watch: {
      $route() {
        this.lastSeenVersion = this.readLastSeen();
      },
    },
    methods: {
      readLastSeen() {
        const raw = window.localStorage.getItem(LAST_SEEN_RELEASE_KEY);
        return raw || null;
      },
      onNavToggle(value) {
        this.$emit('input', value);
      },
    },
  };
</script>
<style scoped lang="scss">
  #nav {
    .logo {
      height: 48px;
      display: flex;
      margin: 4px 0px;
    }
  }
</style>
